import api from "../config/api";
import {
  clearToken,
  isSimulatedAuthenticationEnabled,
  setToken,
} from "../config/enviroment";

export const normalizeSimulatedDocument = value =>
  (value || "").replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

export const getSimulatedDocumentType = documentNumber => {
  if (/^\d{11}$/.test(documentNumber)) return "CPF";
  if (/^[A-Z0-9]{14}$/.test(documentNumber)) return "CNPJ";

  throw new Error(
    "Informe um CPF com 11 digitos ou um CNPJ com 14 caracteres alfanumericos."
  );
};

export const isAuthenticationExpired = (
  authentication,
  now = Date.now()
) => {
  if (!authentication?.access_token) return true;
  if (!authentication.expires_at) return false;

  return now >= Number(authentication.expires_at) * 1000;
};

export const createSimulatedAuthentication = async value => {
  if (!isSimulatedAuthenticationEnabled()) {
    throw new Error("A autenticacao simulada nao esta habilitada neste ambiente.");
  }

  const numeroDocumento = normalizeSimulatedDocument(value);
  getSimulatedDocumentType(numeroDocumento);

  // Evita que um token simulado expirado seja enviado ao endpoint publico.
  clearToken();

  const response = await api.post("autenticacao-simulada/sessao", {
    numeroDocumento,
  });
  const authentication = response.data;

  if (
    !authentication?.access_token ||
    authentication.is_simulated_authentication !== true ||
    isAuthenticationExpired(authentication)
  ) {
    throw new Error("O servidor retornou uma sessao simulada invalida.");
  }

  setToken(authentication);
  return authentication;
};

export const clearSimulatedAuthentication = () => {
  clearToken();
  window.location.assign("/");
};
